/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import { showModal, getCompetency } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
// import TrainingCompleteness from "components/widgets/stats/TrainingCompleteness";
import CompetencyQualification from "components/widgets/stats/CompetencyQualification";
import CompetencyItem from "./CompetencyItem";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import i18n from "i18next";

class Competency extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // guideFetched: false,
      competencyFetched: false,
      currentTab: "50022",
    };
  }

  componentDidMount() {
    this.fetchCompetency();
  }

  componentDidUpdate(prevProps, prevState) {
    // if (
    //   this.props.match.params !== prevProps.match.params &&
    //   this.props.match.params.serviceType
    // ) {
    //   this.setState({ currentTab: this.props.match.params.serviceType });
    // }

    if (prevState.currentTab !== this.state.currentTab) {
      this.fetchCompetency();
    }
  }

  fetchCompetency = () => {
    this.props.getCompetency(
      this.state.currentTab,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = () => {
    this.props.onProcessEnd();
    let showingPersonnels = [];
    this.props.competency.positionEfficiencies.forEach((pe) => {
      pe.personnels.forEach((p) => {
        showingPersonnels.push(false);
      });
    });
    this.setState({
      competencyFetched: true,
      showingPersonnels,
    });
  };
  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  renderDepartmentName = () => {
    switch (this.state.currentTab) {
      case "50020":
        return i18n.t("10049"); //"MechanicalS";
      case "50021":
        return i18n.t("10050"); //"Body / PaintS";
      case "50022":
        return i18n.t("10047"); //"SalesS";
      case "50023":
        return i18n.t("10048"); //"Service AdministrationS";
      default:
        return i18n.t("10047"); //"SalesS";
    }
  };

  handleTabSelected = (selected) => {
    console.log(selected);
    this.setState({
      competencyFetched: false,
      currentTab: selected,
    });

    // switch (selected) {
    //   case "rules":
    //     this.fetchRules();
    //     break;
    //   case "docs":
    //     this.fetchDocs();
    //     break;
    //   case "viewDocument":
    //     this.fetchDocument();
    //     break;
    //   default:
    //     return null;
    // }
  };

  renderPositionEfficiencies = () => {
    if (!this.props.competency) return null;
    // console.log(this.props.competency.positionEfficiencies);
    return (
      <tbody>
        {this.props.competency.positionEfficiencies.map((pe, idx) => {
          return (
            <CompetencyItem
              key={pe.id}
              pe={pe}
              idx={idx}
              personnels={
                this.props.competency.positionEfficiencies[idx].personnels
              }
            />
          );
        })}
      </tbody>
    );
  };

  renderTab = (tabName) => {
    if (!this.state.competencyFetched) {
      return null;
    }
    return (
      <div
        className="tab-pane fade show active"
        id="nav-boya"
        role="tabpanel"
        aria-labelledby="nav-boya-tab"
      >
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 mt-4 p-0 dashboardWidgetArea">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="fgaAlert mt-0 navyBlueAlert">
                  <div className="alertIcon">
                    <span className="iconmford fo-icon-directions-car"></span>
                  </div>
                  <div className="alertText">
                    {this.state.currentTab !== "50022" && (
                      <p>
                        {i18n
                          .t("10163")
                          .replace("_0_", this.props.competency.vehicleCount)}
                        {/* Hesaplamalar <b>{this.props.competency.vehicleCount}</b>
                      araç giriş sayısı üzerinden yapılmıştır. */}
                      </p>
                    )}

                    {this.state.currentTab === "50022" && (
                      <>
                        <p>
                          {i18n
                            .t("10519")
                            .replace("_0_", this.props.competency.vehicleCount)}
                          {/* Hesaplamalar aşağıdaki araç satış miktarları üzerinden yapılmıştır */}
                        </p>
                        {this.props.competency.vehicleSales.map((pe, idx) => {
                          return (
                            <span key={pe.salesType.value} className="mr-3 d-inline-block">
                              {pe.salesType.label} : {pe.vehicleCount}
                            </span>
                          );
                        })}
                      </>
                    )}

                    <p>
                      <Trans desc="ETO:">10164</Trans>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="fgaAlert redAlert">
                  <div className="alertIcon">
                    <span className="iconmford fo-icon-warning"></span>
                  </div>
                  <div className="alertText">
                    <p>
                      {/* * Gelecek Dönem ETO <b>10.07.2020</b> itibariyle devreye
                      alınacaktır. */}
                      <Trans>10165</Trans>
                    </p>
                    <p>
                      {/* * Hesaplama sırasında mevcut personel/lerin değer
                      ortalaması alınmıştır. */}
                      <Trans>10166</Trans>
                    </p>
                    <p>
                      {/* * Gerekli personel sayısı 0 olan pozisyonların ağırlıkları
                      diğer yeterlilikler arasında dağıtılmıştır. */}
                      <Trans>10167</Trans>
                    </p>
                    {/* <p>
                      * İlgili personelin üzerine tıklayarak ilgili
                      personel/leri görebilirsiniz.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 p-0 dashboardWidgetArea">
            <div className="row d-none d-sm-none d-md-flex d-lg-flex">
              {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 p-0">
                    <TrainingCompleteness
                      classNames=" yeterlilikGrafik gelisimPlaniETO"
                      serviceType={this.state.currentTab}
                    />
                  </div>
                </div>
              </div> */}
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 p-0">
                    <CompetencyQualification
                      serviceType={this.renderDepartmentName()}
                      Qualification={this.props.competency.qualification}
                      FutureQualification={
                        this.props.competency.futureQualification
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex d-sm-flex d-md-none d-lg-none">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="topGraphicArea">
                  {/* <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0"
                    style={{ width: "auto !important" }}
                  >
                    <TrainingCompleteness
                      classNames=" yeterlilikGrafik gelisimPlaniETO"
                      serviceType={this.state.currentTab}
                    />
                  </div> */}
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
                    <CompetencyQualification
                      serviceType={this.renderDepartmentName()}
                      Qualification={this.props.competency.qualification}
                      FutureQualification={
                        this.props.competency.futureQualification
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row pb-3">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div id="chartdiv" style={{ display: "none" }}></div>
            <table
              className="table display responsive dtYeterlilik dataTable no-footer dtr-none collapsed"
              id="dtYeterlilik"
            >
              <thead>
                <tr>
                  <th className="all">
                    <div className="tableTitle">
                      <Trans desc="Pozisyon">10064</Trans>
                    </div>
                  </th>

                  <th className="all">
                    <div className="tableTitle">
                      <Trans desc="Personel">10174</Trans>
                    </div>
                  </th>
                  <DesktopBreakpoint>
                    <th className="all">
                      <div className="tableTitle">
                        <Trans desc="Ünvan">10074</Trans>
                      </div>
                    </th>
                    <th className="desktop">
                      <div className="tableTitle">
                        <Trans desc="Gerekli Personel">10169</Trans>
                      </div>
                    </th>
                    <th className="desktop">
                      <div className="tableTitle">
                        <Trans desc="Mevcut Personel">10170</Trans>
                      </div>
                    </th>
                    <th className="desktop">
                      <div className="tableTitle">
                        <Trans desc="Pozisyon Ağırlığı">10171</Trans>
                      </div>
                    </th>
                    <th className="desktop"></th>
                    <th className="all">
                      <div className="tableTitle"></div>
                    </th>
                    <th className="none"></th>
                  </DesktopBreakpoint>
                </tr>
              </thead>
              {this.renderPositionEfficiencies()}
            </table>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-none d-sm-none d-md-flex d-lg-flex">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Yeterlilik">10037</Trans>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-flex d-sm-flex d-md-none d-lg-none">
              <div className="sssBaslik">
                <Trans desc="Yeterlilik">10037</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <Tab.Container
                id="nav-tab"
                defaultActiveKey="50022"
                activeKey={this.state.currentTab}
                onSelect={this.handleTabSelected}
              >
                <nav className="scrollNav">
                  <Nav variant="tabs" role="tablist">
                    <Nav.Item>
                      <Nav.Link
                        onClick={() => this.setState({ currentTab: "50022" })}
                        eventKey="50022"
                      >
                        <span className="iconmford fo-icon-directions-car"></span>{" "}
                        <Trans desc="Satış">10047</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() => this.setState({ currentTab: "50023" })}
                        eventKey="50023"
                      >
                        <span className="iconmford fo-icon-perm-data-setting"></span>{" "}
                        <Trans desc="Servis İdari">10048</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() => this.setState({ currentTab: "50021" })}
                        eventKey="50021"
                      >
                        <span className="iconmford fo-icon-format-paint"></span>{" "}
                        <Trans desc="Kaporta / Boya">10050</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() => this.setState({ currentTab: "50020" })}
                        eventKey="50020"
                      >
                        <span className="iconmford fo-icon-build"></span>{" "}
                        <Trans desc="Mekanik">10049</Trans>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </nav>
                <Tab.Content>
                  <Tab.Pane eventKey="50022">
                    {this.renderTab("50022")}
                  </Tab.Pane>
                  <Tab.Pane eventKey="50023">
                    {this.renderTab("50023")}
                  </Tab.Pane>
                  <Tab.Pane eventKey="50021">
                    {this.renderTab("50021")}
                  </Tab.Pane>
                  <Tab.Pane eventKey="50020">
                    {this.renderTab("50020")}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    competency: state.competency.data,
  };
};

export default connect(mapStateToProps, { getCompetency, showModal })(
  requireAuth(containsLongRunningProcess(Competency))
);
